import PropTypes from 'prop-types'
import React from 'react'
import Gravatar from 'react-gravatar'
import styles from './tagValue.less'

const TagValue = ({ value, children, onRemove, disabled }) => (
  <div className={styles.value} title={value.label}>
    <span className="Select-value-label">
      {value.email
        ? <Gravatar
            title={`added by ${value.email}`}
            email={value.email}
            size={22}
            className={styles.avatar}
          />
        : null}
      <span className={styles.label} title={value.label}>{children}</span>
      {disabled
        ? null
        : <span
            title="Remove"
            className={styles.removeBtn}
            aria-hidden="true"
            onMouseDown={() => onRemove(value)}
          >
            ×
          </span>}
    </span>
  </div>
)

TagValue.propTypes = {
  children: PropTypes.node,
  value: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
    email: PropTypes.string,
  }).isRequired,
  onRemove: PropTypes.func,
}

export default TagValue



// WEBPACK FOOTER //
// ./src/components/TagValue.js